import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  ModelBase, 
  PlayerObject,
} from "@models";
import { DATA_TYPE_INFO } from "@dndModels/Constants";

import CommonUtilities from "@utilities/common_utilities";
import DandDAPI from "@dndUtilities/system_api";

import ObjectIndex from "@components/Navigation/ObjectIndex";
import CopyButton from "@components/input/buttons/CopyButton";
import ToastBox from "@components/display/ToastBox";
import { DataType } from '@dndModels/Types';

interface Props { 
  data_type: DataType;
  extra_filter?: (obj: ModelBase | PlayerObject) => boolean;
  extra?: (obj: ModelBase | PlayerObject) => React.ReactNode;
  name_display?: (obj: ModelBase | PlayerObject) => React.ReactNode;
  disabled?: boolean;
  constants?: any;
  show_image?: boolean;
  sort?: (obj1: ModelBase | PlayerObject, obj2: ModelBase | PlayerObject) => number;
  save_all?: boolean;
  log_it?: boolean;
  extra_by_add?: () => React.ReactNode;
  special_update?: (obj: ModelBase | PlayerObject, onSuccess: () => void) => void;
  quick_fields?: string[];
  get_filtered?: (filtered: string[]) => void;
}

const common_util = CommonUtilities.getInstance();
const api = DandDAPI.getInstance();

export default function NonFSIndex({
  data_type,
  extra_filter,
  name_display,
  constants = {},
  show_image = false,
  save_all = false,
  log_it = false,
  extra,
  extra_by_add,
  get_filtered,
  special_update,
  quick_fields
}: Props) {
  const [toast_time, setToastTime] = useState(-1);

  const dt_info = DATA_TYPE_INFO.find(o => o.data_type === data_type);

  if (!dt_info) {
    return <>Invalid Data Type</>;
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <ObjectIndex 
            data_type={data_type}
            name_display={name_display}
            log_it={log_it}
            save_all={save_all}
            extra_filter={extra_filter}
            show_image={show_image}
            constants={constants}
            extra_by_add={extra_by_add}
            get_filtered={get_filtered}
            extra={(obj: ModelBase | PlayerObject) => {
              if (extra) {
                return extra(obj);
              } else if (obj instanceof ModelBase) {
                return (
                  <CopyButton
                    label="Copy to Clipboard"
                    onClick={() => {
                      api.getFullObjectForClipboard(data_type, obj._id).then(res => {
                        // console.log(res);
                        navigator.clipboard.writeText(JSON.stringify(res));
                        setToastTime(common_util.get_time_number());
                      });
                    }}
                  />
                );
              } else {
                return <span></span>;
              }
            }}
            special_update={special_update}
            quick_fields={quick_fields}
          />
        </Grid>
        <ToastBox
          openTime={ toast_time }
        >
          {dt_info.name} copied to Clipboard
        </ToastBox>
      </Grid>
    ); 
  } 
}
